import { render, staticRenderFns } from "./hxyq.vue?vue&type=template&id=c333f124&scoped=true"
import script from "./hxyq.vue?vue&type=script&lang=js"
export * from "./hxyq.vue?vue&type=script&lang=js"
import style0 from "./hxyq.vue?vue&type=style&index=0&id=c333f124&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c333f124",
  null
  
)

export default component.exports